import { gql } from "@apollo/client";

const CREATE_LOCATION = gql`
  mutation CreateLocation($location: LocationCreateInput!, $users: [ID]) {
    createLocation(location: $location, users: $users) {
      success
      message
      location {
        id
        name
        address {
          fullName
          street
          colony
          exteriorNumber
          postcode
          city
          country
          location {
            type
            coordinates
          }
        }
      }
    }
  }
`;

const GET_ZONES = gql`
  query getZones($params: QueryParams) {
    zones(params: $params) {
      results {
        id
        name
        subZones {
          id
          name}
      }
    }
  }
`;

export { CREATE_LOCATION, GET_ZONES };
